module.exports = __webpack_public_path__ + "static/img/legend_spanish_dark.e965c6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/legend_spanish_dark.png
// module id = 2K20
// module chunks = 94